import { useState } from 'react';
function Product({ product, onRemove }) {
	return (
		<div>
			<h3>{product.name}</h3>
			<p>{product.price}</p>
			<button onClick={() => onRemove(product.id)}>Remove from Cart</button>
		</div>
	);
}
export default Product